import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[display-if]',
    standalone: false
})
export class DisplayIfDirective implements OnChanges {

  constructor(private el: ElementRef<HTMLElement>) {
      this.parents = this.findParents();
  }
  
  ngOnChanges(changes: SimpleChanges): void {

    if (this.displayIf != null) {
      if (!this.displayIf) {
        this.el.nativeElement.style.display = "none";
      }
      else {
        this.el.nativeElement.style.display = "";
      }
      this.el.nativeElement.setAttribute("display-if", this.displayIf.valueOf().toString().toLowerCase());
      this.updateParents();
    }

   
  }

   
  findParents() {
    var parents = new Array<HTMLElement>();

    var parent: HTMLElement = this.el.nativeElement.parentElement;
    while (parent != null) {
      if (parent.classList.contains(this.hideParentClassName)) {
        parents.push(parent);
      }

      parent = parent.parentElement;
    }

    return parents;
  }
  updateParents() {
    this.parents.forEach(parent => {
      var childItems = parent.querySelectorAll("[display-if='true'] ");
      if (childItems.length > 0)
        parent.style.display = "";
      if (childItems.length == 0)
        parent.style.display = "none";
    })
  }

  parents: HTMLElement[];

  @Input("display-if-hide-parents-css")
  hideParentClassName?: string = "nav-item";


  @Input("display-if")
  displayIf?: boolean = null;

}
